
import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import DataGridCellExpand from "components/DataGridCellExpand/DataGridCellExpand";
import { Box, IconButton, Typography } from "@mui/material";
import { BoxFC, BoxFR } from "components/BoxCustom";
import { AddCircleRounded, CloseRounded } from "resource/muiImport";
import PettyCashDialog from "pages/Menu1/PettyCash/PettyCashDialog";
import AddAdvanceDialog from "pages/Menu1/PettyCash/AddAdvanceDialog";
import ReimbursementDialog from "pages/Menu1/PettyCash/ReimbursementDialog";
import { pcTrnsColumns } from "./dailyJobDialogColumns";
import ButtonGroupSelection from "components/ButtonGroupSelection";
import { green, red, yellow } from "@mui/material/colors";
import { GlobalStateContext } from "contexts/GlobalStateContext";

let selectedPCTrnsId = null;

const pcViewModeIdLabels = [
  { id: "PCTRNS", label: "เงินจ่าย" },
  { id: "PCITEM", label: "ใบเสร็จ" },
]

const PCComponent = ({ joData, setJoData, ptDataTable, setPTDataTable, piDataTable, onPettyCashFinish }) => {

  const { msData } = useContext(GlobalStateContext)

  const [pcViewMode, setPCViewMode] = useState("PCTRNS")
  const [dialogPettyCashOpen, setDialogPettyCashOpen] = useState(false)
  const [dialogAddAdvanceOpen, setDialogAddAdvanceOpen] = useState(false)
  const [dialogReimbursementOpen, setDialogReimbursementOpen] = useState(false)

  const ptDataTableMemo = useMemo(() => {
    // return ptDataTable.map(pt=> pt.ExpId === 2? pt: ({...pt, ExpNm: `${pt.ExpNm} ${pt.Dscp ? `(${pt.Dscp})` : ''}` }))
    return ptDataTable.map(pt => ({
      ...pt,
      ExpNm: pt.ExpId === 2 ? pt.ExpNm : `${pt.ExpNm} ${pt.Dscp ? `(${pt.Dscp})` : ''}`,
    }))
  }, [ptDataTable])

  const piDataTableMemo = useMemo(() => {
    return piDataTable.map(pi => pi.ExpId === 2 ? pi : ({ ...pi, ExpNm: `${pi.ExpNm} ${pi.Dscp ? `(${pi.Dscp})` : ''}` }))
  }, [piDataTable])

  const payText = useMemo(() => {
    const drv = msData.driverObj[joData.processDrvId]
    if (drv) {
      const filtered = ptDataTable.filter(pt => pt.TmpUsrAccId)
      if (filtered.length > 0) {
        const total = filtered.reduce((sum, curr) => sum + (+curr.InOutAmnt || 0), 0)
        return `จ่ายเงิน ${total} บาท ให้ ${drv.NName}`
      }
    }
    return ""
  }, [joData.processDrvId, msData, ptDataTable])

  const handleAddPettyCash = useCallback(() => {
    if (pcViewMode === "PCTRNS") {
      setDialogAddAdvanceOpen(true)
    } else {
      setDialogReimbursementOpen(true)
    }
  }, [pcViewMode])


  const handlePCCellClick = useCallback(({ field, row }) => {
    if (field === "ShowDetail") {
      if (pcViewMode === "PCTRNS") {
        selectedPCTrnsId = row.PrPCTrnsId ? row.PrPCTrnsId : row.PCTrnsId
      } else {
        selectedPCTrnsId = row.PCTrnsId
      }
      setDialogPettyCashOpen(true)
    }
  }, [pcViewMode])

  const handleRemoveProcessDrvId = useCallback(() => {
    setJoData(o => ({ ...o, processDrvId: null }))
  }, [setJoData])

  const handleRemoveTmpUsrAccId = useCallback((row) => () => {
    setPTDataTable(o=> o.map(pt=>({
      ...pt, 
      TmpUsrAccId: pt.PCTrnsId === row.PCTrnsId ? null : pt.TmpUsrAccId,
      UsrNNm: pt.PCTrnsId === row.PCTrnsId ? (pt.UsrAccId ? pt.UsrAccNNm : null) : pt.UsrNNm
    })))
  }, [setPTDataTable])

  useEffect(() => {
    setPTDataTable(o => o.map(pt => ({
      ...pt,
      TmpUsrAccId: pt.UsrAccId ? null : joData.processDrvId,
      UsrNNm: pt.UsrAccId ? pt.UsrNNm : (joData.processDrvId ? msData.driverObj[joData.processDrvId]?.NName : null)
    })))
  }, [joData.processDrvId, msData.driverObj, setPTDataTable])
  return (

    <BoxFC flex={1.5} sx={{ gap: 0, mb: 0.5 }}>
      <BoxFR sx={{ gap: 0 }}>
        <ButtonGroupSelection
          buttonSX={{ px: 2, py: 0 }}
          idLables={pcViewModeIdLabels}
          value={pcViewMode}
          setValue={setPCViewMode} />
        {/* <Typography fontWeight="bold">เงินจ่าย</Typography> */}
        <IconButton sx={{ p: 0, ml: 1 }} onClick={handleAddPettyCash}>
          <AddCircleRounded color="primary" />
        </IconButton>
        <Box flex={1} />
        {payText ?
          <Typography sx={{
            backgroundColor: yellow[200], color: red[800]
            , pl: 2, pr: 1, borderRadius: 1
          }}>
            {payText}
            <IconButton sx={{ p: 0, ml: 1 }} onClick={handleRemoveProcessDrvId}>
              <CloseRounded fontSize="small" sx={{ color: red[800] }} />
            </IconButton>
          </Typography>
          : null
        }
      </BoxFR>
      <Box flex={1} sx={{
        '& .row-complete': { bgcolor: green[50], "&:hover": { bgcolor: green[100] } },
        '& .tmp-usr-acc-id-cell': {bgcolor: yellow[100], color: red[800] }
      }}>
        <DataGridCellExpand
          density="compact"
          hideFooter
          hideToolbar
          rows={pcViewMode === "PCTRNS" ? ptDataTableMemo : piDataTableMemo}
          columns={pcTrnsColumns(handleRemoveTmpUsrAccId)}
          onCellClick={handlePCCellClick}
          getRowClassName={({ row }) => row.IsCmpt === 1 ? 'row-complete' : ''}
        />
      </Box>


      <PettyCashDialog
        selectedId={selectedPCTrnsId}
        dialogOpen={dialogPettyCashOpen}
        setDialogOpen={setDialogPettyCashOpen}
        onFinish={onPettyCashFinish} />
      <AddAdvanceDialog
        pcTrnsId={null}
        dialogOpen={dialogAddAdvanceOpen}
        setDialogOpen={setDialogAddAdvanceOpen}
        onFinish={onPettyCashFinish}
        isFromJobOrder={false}
        usrAccId={joData.processDrvId}
        joData={joData} />
      <ReimbursementDialog
        dialogOpen={dialogReimbursementOpen}
        setDialogOpen={setDialogReimbursementOpen}
        onFinish={onPettyCashFinish}
        joData={joData} />
    </BoxFC>
  )
}

export default React.memo(PCComponent);